import { Pipe, PipeTransform } from '@angular/core';
import { isTextTruncated } from '@core/helper';

@Pipe({
  name: 'isTruncated',
  pure: false,
})
export class IsTruncatedPipe implements PipeTransform {
  transform(id: string): any {
    const elementRef = document.querySelector(`#${id}`);
    return !isTextTruncated(elementRef);
  }
}
